import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const HomeComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__home"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
    >
      <g clipPath="url(#clip0_2440_17201)">
        <path
          d="M2 6.0606L8 1.39394L14 6.0606L14 13.3939C14 13.7476 13.8595 14.0867 13.6095 14.3367C13.3594 14.5868 13.0203 14.7273 12.6667 14.7273L3.33333 14.7273C2.97971 14.7273 2.64057 14.5868 2.39052 14.3367C2.14048 14.0867 2 13.7476 2 13.3939L2 6.0606Z"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 14.7273L6 8.06061H10V14.7273"
          stroke={colorVar}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2440_17201">
          <rect width="16" height="16" fill={colorVar} transform="translate(0 0.0606079)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Home = withIcon(HomeComponent);
